/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1GetTransportBrandsResponse } from '../../entities/v1/GetTransportBrandsResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { v1TransportBrandModelSchema } from './transportBrandModelSchema'
import { z } from 'zod'

export const v1GetTransportBrandsResponseSchema = z.object({
  transport_brands: z.array(z.lazy(() => v1TransportBrandModelSchema)),
}) as unknown as ToZod<V1GetTransportBrandsResponse>